document.addEventListener("DOMContentLoaded", function() {
  const statusSelect = document.getElementById("status-select");
  const dateCompletedField = document.getElementById("date-completed-field");

  if (!statusSelect || !dateCompletedField) return;

  function toggleDateCompleted() {
    if (statusSelect.value === "ready") {
      dateCompletedField.style.display = "block";
    } else {
      dateCompletedField.style.display = "none";
    }
  }

  // Run once on load
  toggleDateCompleted();

  // Run whenever status changes
  statusSelect.addEventListener("change", toggleDateCompleted);
});
